import React from 'react'
import { Flex, Heading, Text, Link } from 'system'

export const InvalidPreview = ({ children }) => (
  <Flex
    justifyContent="center"
    alignItems="center"
    height="100vh"
    width="100vw"
    flexDirection="column"
    bg="#EDF2F7"
  >
    <Text fontFamily="system-ui" textAlign="center" color="#4A5568">
      <Heading
        as="h1"
        fontWeight="semibold"
        mb="4rem"
        fontSize="2rem"
        maxWidth="24ch"
        lineHeight="1.5"
      >
        {children}
      </Heading>
      <Link
        fontSize="1.25rem"
        textStyle="trackedCaps"
        fontWeight={700}
        color="#63B3ED"
        py="1rem"
        px="1.5rem"
        borderRadius="22px"
        border="2px solid"
        borderColor="#63B3ED"
        href="/"
        transitionProperty="color, background, border-color"
        css={{
          outline: 'none',
          userSelect: 'none',
          cursor: 'pointer',

          '&:hover, &:focus': {
            color: '#2b6cb0',
            backgroundColor: '#bee3f8',
            borderColor: '#bee3f8',
          },
        }}
      >
        Go to homepage
      </Link>
    </Text>
  </Flex>
)
